import React from 'react'
import GalleryPage from '../Components/Gallery/Gallery'
import NavBar from '../Components/Home/HNavbar/HNavbar'

const Gallery = () => {
  return (
    <div>
    <NavBar/>
    <GalleryPage/>
    </div>
  )
}

export default Gallery
